import { useState, useCallback } from "react";

function useTagSelection() {
	const [selectedOptions, setSelectedOptions] = useState([]);
	
	const onSelectionChange = useCallback(
		(selectedOption) => {
			setState(state => {
				const selectedOptions = [...state];
				const searchIndex = selectedOptions.map(i => i.key).indexOf(selectedOption.key);
				if (searchIndex > -1) {
				  selectedOptions.splice(searchIndex, 1);
				  return selectedOptions;
				} else {
				  return [...selectedOptions, selectedOption];
				}
			});
		},
		[]
	)

	return [selectedOptions, onSelectionChange];
}

export {
	useTagSelection
}